import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sellerimg from "../img/Sellerimg.svg";
import api from "../../api/axiosInstance";
import { useActiveTooltipDataPoints } from "recharts";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState(""); // To store the email entered by the user
  const [loading, setLoading] = useState(false); // For showing loading state
  const [message, setMessage] = useState(""); // For showing success/error message
  const [messageType, setMessageType] = useState(""); // To determine the message type (success/error)
  const [hasSent, setHasSent] = useState(false); // Track if the email was successfully sent
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    let timer;

    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }

    if (countdown === 25) {
      setMessage("");
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [countdown]);

  const handleForgotPassword = async (e) => {
    e.preventDefault(); // Prevent form submission

    // Validate the email format (basic validation)
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setMessageType("error");
      setMessage("Enter your registered email address.");
      return;
    }

    if (countdown > 0) {
      return;
    }

    setLoading(true); // Set loading state

    try {
      // Call the API to initiate the password reset
      const response = await api.post(
        "/display/api/v1/initiate-forget-password",
        {
          email: email,
        }
      );

      // Check if the response is successful
      if (response.status === 200 && response.data.status === "success") {
        setMessageType("success");
        setMessage("Password reset link sent successfully.");
        setHasSent(true); // Mark as sent
        setCountdown(30);
      } else {
        // If response status is not 200 or the message is "failed"
        setMessageType("error");
        setMessage(
          response.data.message ||
            "Failed to send reset link. Please try again."
        );
      }
    } catch (error) {
      if (error.response) {
        // Check for the response from the backend
        setMessageType("error");
        setMessage(
          error.response.data.message ||
            "Something went wrong. Please try again."
        );
      } else {
        // For network or other errors
        setMessageType("error");
        setMessage("Something went wrong. Please try again.");
      }
    }

    setLoading(false); // Reset loading state
  };

  return (
    <div className="min-h-screen flex flex-col justify-center gap-12 lg:flex-row px-5">
      {/* Left Content */}

      <div
        className="w-full lg:w-1/2 min-h-[300px] lg:min-h-screen bg-no-repeat bg-center bg-cover"
        style={{
          backgroundImage: `url(${Sellerimg})`,
          backgroundSize: "contain",
        }}
      ></div>

      {/* Right Content */}
      <div className="w-full lg:w-1/2 flex justify-center items-center">
        <div className="max-w-md w-full text-left px-6 ">
          <div>
            <h1 className="text-3xl font-semibold font-inter">
              Forgot Your Password?
            </h1>
            <p className="text-black-600 mb-6 mt-4 font-inter">
              No worries! We’ll send a password reset link to your registered
              email address once you send the forgot password request.
            </p>
          </div>

          <div className="">
            {/* <p className="text-sm text-black-600 font-inter mb-2">
              Enter your registered email address
            </p> */}
            <input
              type="email"
              placeholder="Enter your registered email address"
              className="w-full px-4 py-2 border-2 border-[#9061DB] rounded-md bg-transparent focus:outline-none focus:ring-2 focus:ring-[#9061DB] font-inter mb-2 text-sm"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setMessage("");
              }}
            />
          </div>

          {/* Show message after submitting the form */}
          {message && (
            <p
              className={`text-sm font-inter mb-4 ${
                messageType === "error" ? "text-red-500" : "text-green-500"
              }`}
            >
              {message}
            </p>
          )}

          <div className="flex justify-between items-end mt-5">
            <span
              className="text-xs cursor-pointer"
              onClick={() => navigate(-1)}
            >
              Back to{" "}
              <span className="text-sm font-semibold text-[#9367D7]">
                Login
              </span>{" "}
            </span>

            <button
              type="submit"
              onClick={handleForgotPassword}
              //onClick={()=>{navigate("/resetPassword")}}
              className={`bg-primary text-white px-8 py-2 text-sm font-semibold rounded-md font-inter hover:scale-105 transition-transform duration-300 ${
                loading || countdown > 0 ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={loading}
              style={{ willChange: "transform" }}
            >
              {loading ? "Sending..." : hasSent ? "Resend" : "Send"}
            </button>
          </div>

          <div className="float-right">
            {countdown > 0 && (
              <span className="text-gray-500 text-xs  font-semibold">
                Resend in {countdown}s
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
